import { Link } from "react-router-dom";
import { GraduationCap } from "@phosphor-icons/react";

const SECTIONS = [
  {
    title: "Tools",
    links: [
      { label: "Free Rubric Generator", href: "/#tool" },
      { label: "Free Downloads", href: "/#downloads" },
      { label: "Printable Resources", href: "/#resources" },
    ],
  },
  {
    title: "Site",
    links: [
      { label: "Home", to: "/" },
      { label: "About", to: "/about" },
      { label: "Contact", to: "/contact" },
      { label: "Privacy Policy", to: "/privacy" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="app-footer"
      className="bg-[#F8F7F4] border-t border-[#E5E7EB] no-print"
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2.5 mb-3">
              <span className="w-10 h-10 bg-[#A8B5A2] rounded-xl flex items-center justify-center shadow-sm">
                <GraduationCap size={22} weight="bold" />
              </span>
              <span className="font-display font-black text-xl tracking-tight">
                TeacherToolsLab
              </span>
            </Link>
            <p className="text-sm text-[#475569] font-medium leading-relaxed max-w-xs">
              Free, printable rubrics and classroom tools — made for teachers, by
              teachers.
            </p>
          </div>

          {SECTIONS.map((section) => (
            <div key={section.title}>
              <h4 className="font-bold text-xs uppercase tracking-widest text-[#0A0A0A] mb-3">
                {section.title}
              </h4>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.label}>
                    {link.to ? (
                      <Link
                        to={link.to}
                        data-testid={`footer-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                        className="text-sm font-medium text-[#475569] hover:text-[#0A0A0A] transition-colors"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        data-testid={`footer-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                        className="text-sm font-medium text-[#475569] hover:text-[#0A0A0A] transition-colors"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-[#E5E7EB] flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-[#64748B] font-medium">
          <p>© {new Date().getFullYear()} TeacherToolsLab. All rights reserved.</p>
          <p className="max-w-xl md:text-right">
            This website provides general educational resources and is not affiliated
            with any state education department.
          </p>
        </div>
      </div>
    </footer>
  );
}
